import React, { useEffect, useState } from 'react';
import { useAppContext } from "contexts/AppContext"
import './PortfolioCarousel.css';
import PortfoliosSummaryChart from "views/app/PortfoliosSummaryChart/PortfoliosSummaryChart"

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const PortfolioCarousel = ({
  portfolios,
  setPortfolioName,
  setSumProfit,
  activeIndex: controlledActiveIndex,
  onActiveIndexChange,
  hideOverlayControls = false,
}) => {
  const { getPortfolioName, getUserTypeName, getTransactionType } = useAppContext()

  const [internalActiveIndex, setInternalActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const isControlled =
    typeof controlledActiveIndex === "number" && typeof onActiveIndexChange === "function";
  const activeIndex = isControlled ? controlledActiveIndex : internalActiveIndex;

  const applyIndex = (nextIndex) => {
    if (isControlled) onActiveIndexChange(nextIndex);
    else setInternalActiveIndex(nextIndex);
  };

  useEffect(() => {
    setPortfolioName(getPortfolioName(Number(portfolios[activeIndex]?.id)))
  }, [activeIndex, portfolios, getPortfolioName, setPortfolioName])

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === portfolios.length - 1 ? 0 : activeIndex + 1;
    applyIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? portfolios.length - 1 : activeIndex - 1;
    applyIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    applyIndex(newIndex);
  };

  const convertData = (data) => {
    const convertedData = {};
    convertedData[data.id] = {
      Hankintahinta: data.Hankintahinta,
      Markkina_arvo: data.Markkina_arvo,
      Realisoitumattomat_tuotot: data.Realisoitumattomat_tuotot,
      Realisoituneet_tuotot: data.Realisoituneet_tuotot,
    };
    return convertedData;
  }


  const slides = portfolios.map((portfolio, index) => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={portfolio.id}
      className=""
    >
    <PortfoliosSummaryChart data={convertData(portfolio)} />

    </CarouselItem>
  ));

  return (
    <Carousel activeIndex={activeIndex} next={next} previous={previous}>
      {!hideOverlayControls && (
        <CarouselIndicators items={portfolios} activeIndex={activeIndex} onClickHandler={goToIndex} />
      )}
      {slides}
      {!hideOverlayControls && (
        <>
          <CarouselControl className="custom-gray" direction="prev" directionText="Previous" onClickHandler={previous} />
          <CarouselControl className="custom-gray" direction="next" directionText="Next" onClickHandler={next} />
        </>
      )}
    </Carousel>
  );
};

export default PortfolioCarousel;




// import React, { useState } from 'react';
// import {
//   Carousel,
//   CarouselItem,
//   CarouselControl,
//   CarouselIndicators,
//   CarouselCaption
// } from 'reactstrap';

// const Example = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [animating, setAnimating] = useState(false);

//   const items = [
//     {
//       id: 1,
//       src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa1d%20text%20%7B%20fill%3A%23555%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa1d%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22285.921875%22%20y%3D%22218.3%22%3EFirst%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
//       altText: 'Slide 1',
//       caption: 'Slide 1'
//     },
//     {
//       id: 2,
//       src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa20%20text%20%7B%20fill%3A%23444%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa20%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23666%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22247.3203125%22%20y%3D%22218.3%22%3ESecond%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
//       altText: 'Slide 2',
//       caption: 'Slide 2'
//     },
//     {
//       id: 3,
//       src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa21%20text%20%7B%20fill%3A%23333%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa21%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23555%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22277%22%20y%3D%22218.3%22%3EThird%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
//       altText: 'Slide 3',
//       caption: 'Slide 3'
//     }
//   ];

//   const next = () => {
//     if (animating) return;
//     const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
//     setActiveIndex(nextIndex);
//   };

//   const previous = () => {
//     if (animating) return;
//     const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
//     setActiveIndex(nextIndex);
//   };

//   const goToIndex = (newIndex) => {
//     if (animating) return;
//     setActiveIndex(newIndex);
//   };

//   const slides = items.map((item) => (
//     <CarouselItem
//       onExiting={() => setAnimating(true)}
//       onExited={() => setAnimating(false)}
//       key={item.id}
//     >
//       <img src={item.src} alt={item.altText} />
//       <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
//     </CarouselItem>
//   ));

//   return (
//     <Carousel activeIndex={activeIndex} next={next} previous={previous}>
//       <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
//       {slides}
//       <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
//       <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
//     </Carousel>
//   );
// };

// export default Example;

